export default __webpack_public_path__ + "static/media/linkedin-white.e04b3d52.svg";